export default __webpack_public_path__ + "static/media/icon-randomization.f7524ace.svg";